import { Theme } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import React from 'react';
import MyButton from '../../UI/MyButton/MyButton';
const styles = (theme: Theme) =>
  createStyles({
    root: {},
    paper: {
      margin: 'auto'
    },
    content: { paddingTop: '1.5rem' },
    title: {
      textTransform: 'capitalize',
      paddingBottom: '1rem',
      paddingTop: '1rem',
      borderBottom: `1px solid ${theme.palette.text.primary}`
    },
    actions: { marginBottom: '1rem', marginTop: 0 }
  });

class ConfirmationDialog extends React.Component<IConfirmationDialogProps> {
  public render() {
    const {
      classes,
      open,
      onCloseDialog,
      onProceedDialog,
      // content,
      title
    } = this.props;
    return (
      <Dialog
        open={open}
        onClose={onCloseDialog}
        aria-labelledby="form-dialog-title"
        className={classes.root}
        classes={{ paper: classes.paper }}
        disableBackdropClick
      >
        <DialogTitle className={classes.title} id="form-dialog-title">
          {title}
        </DialogTitle>
        <DialogContent className={classes.content}>
          <DialogContentText>{this.props.children}</DialogContentText>
        </DialogContent>
        <DialogActions className={classes.actions}>
          <MyButton
            onClick={onProceedDialog}
            btnType={'yellow'}
            style={{ marginRight: '1rem' }}
            disabled={this.props.proceedDisabled}
          >
            Proceed
          </MyButton>
          <MyButton onClick={onCloseDialog} btnType={'transparent'}>
            Cancel
          </MyButton>
        </DialogActions>
      </Dialog>
    );
  }
}
interface IConfirmationDialogOwnProps extends WithStyles<typeof styles> {
  open: boolean;
  onCloseDialog: () => void;
  onProceedDialog: () => void;
  content: string | React.ReactNode;
  title: string | React.ReactNode;
  proceedDisabled?: boolean;
}
type IConfirmationDialogProps = IConfirmationDialogOwnProps;
export default withStyles(styles)(ConfirmationDialog);
